/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import parser from 'html-react-parser';
import { Button } from 'react-bootstrap';
import { withStore } from 'store';
import { useRouteMatch } from 'react-router';
import styles from './styles.module.scss';
import 'react-quill/dist/quill.snow.css';
import iconEdit from '../../../assets/img/icon_edit.svg';
import { useWindowSize } from 'hooks';

const TableWelcomeMessage = ({
  readOnly = false,
  value = '',
  onSave,
  onlyView = false,
}) => {
  const [, { isMobile }] = useWindowSize();
  const [textValue, setTextValue] = useState(value);
  const [edit, setEdit] = useState(false);

  const modules = {
    toolbar : ['bold', 'italic', 'underline']
  };

  useEffect(() => {
    if(value) {
      setTextValue(value)
    }
  }, [value])
  
  const saveMessage = async () => {
    if (!textValue) return;
    setTextValue(textValue);
    try {
      const body = { gift_table: { welcome_message: textValue } };
      onSave(body);
      setEdit(false);
    } catch (e) {
      console.log(e);
    }
  };
  const guestRouteEventId = useRouteMatch({
    path: '/:eventId/:name',
    exact: true,
  });
  const guestRouteInvitado = useRouteMatch({
    path: '/invitado/:eventId',
    exact: true,
  });
  const validationWelcomeMessage =
    guestRouteEventId || guestRouteInvitado || !onlyView;

  return (
    <>
      {validationWelcomeMessage && (
        <div className={styles.TableWelcomeMessage}>
          {!onlyView && !readOnly && (
            <button
              className={styles.edit}
              type="button"
              onClick={() => setEdit(!edit)}
            ><i className="fa fa-pencil fa-1x" style={{color:'red'}} />
            </button>
          )}

          <>
            {!edit ? (
              <p
                className={styles.text}
                style={{
                  display: 'inline-block',
                  wordWrap: 'anywhere',
                }}
              >{parser(value) || 'Bienvenido a mi evento'}
              </p>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Escribe tu mensaje"
                  disabled={!edit}
                  onChange={(e) => setTextValue(e.target.value)}
                  value={textValue}
                  className={styles.inputedit}
                  onBlur={isMobile?saveMessage:null}
                />
              </>
            )}
          </>

          {!onlyView && edit && !isMobile && (
            <Button className="m-2" onClick={saveMessage}>
              Guardar
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    tableWelcomeMessage: state.giftTable.giftTableInfo.data?.welcome_message,
    readOnly: state.giftTable.giftTableInfo.data?.status === 'Cancel',
  }),
})(TableWelcomeMessage);
